import { useEffect, useRef } from "react";
import { Nullable } from "shared/lib/typeCheck.lib";
import { AppDOM } from "shared/utils/app.utils";

export const useResize = (callback: Nullable<() => void>): void => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const container = AppDOM.appContainer;
    if (!container) return;

    const observer = new ResizeObserver(() => {
      callbackRef.current?.();
    });

    observer.observe(container);

    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);
};
